import { CommonModule, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ApplicationTypeParameterLogin } from '../../../interfaces/application-type-param-login.interface';
import { DxLookupModule, DxSwitchModule, DxTextBoxModule } from 'devextreme-angular';
import { ParameterType as ALParameterType } from '../../../enums/parameter-type.enum';
import { ParameterType as ASParameterType } from '@asamco/management-portal/shared';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsValidatorDirective, CustomErrors } from '@asamco/base';
import { BehaviorSubject } from 'rxjs';

@Component({
	selector: 'app-link-edit-application-login-fields',
    templateUrl: './link-edit-application-login-fields.component.html',
    styleUrls: ['./link-edit-application-login-fields.component.scss'],
	standalone: true,
	imports: [
		CommonModule,
		DxSwitchModule,
		FormsModule,
        ReactiveFormsModule,
		DxLookupModule,
		AsValidatorDirective,
		DxTextBoxModule,
		NgIf,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkEditApplicationLoginFieldsComponent implements OnInit {
	@Input() param: ApplicationTypeParameterLogin
	@Input() formGroup: FormGroup;

	public readonly asParameterType = ASParameterType;
	public readonly alParameterType = ALParameterType;

	/**
	 *
	 */
	constructor() {
		//console.log(this.formGroup);

	}
	ngOnInit(): void {

	}

	public customErrors: CustomErrors = {
		ERROR_REQUIRED: 'This field is required',
		ERROR_MAXLENGTH: 'This field exceeds the maximum allowed amount of characters',
	};

	leadingOrTrailingSpace: { [control: string]: boolean } = {}; // Flag to track leading or trailing space

	public readonly passwordTextBoxMode$ = new BehaviorSubject<'text' | 'password'>('password');
	public readonly passwordIcon$ = new BehaviorSubject<'far fa-eye' | 'far fa-eye-slash'>('far fa-eye');

	public passwordButtonOptions = {
		type: 'as-password-toggle',
		icon: this.passwordIcon$.value,
		onClick: () => {
			this.passwordIcon$.next(this.passwordIcon$.value === 'far fa-eye' ? 'far fa-eye-slash' : 'far fa-eye');
			this.passwordTextBoxMode$.next(this.passwordTextBoxMode$.value === 'text' ? 'password' : 'text');
		},
	};


	hasLeadingOrTrailingSpace(controlName: string): boolean {
		return this.leadingOrTrailingSpace[controlName];
	  }

	  getNumericType(param: ApplicationTypeParameterLogin): number {
		return Number(param.type);
	  }

}
